module.exports = __webpack_public_path__ + "img/Versorgungstrupp_Materialerhaltung.66a8f73a.svg";